import { Circle } from "tamagui";
import { Label } from "./Label";

function stringToHslColor(str: string, saturation: number, lightness: number) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const h = hash % 360;

  return `hsl(${h}, ${saturation}%, ${lightness}%)`;
}

export const UserCircle = ({
  name,
  size = 32,
  maxSize,
  showBorder,
}: {
  name: string;
  size?: number;
  showBorder?: boolean;
  maxSize?: number;
}) => {
  const nameSplit = name.split(" ");
  const initials =
    nameSplit.length > 1
      ? nameSplit[0].slice(0, 1) + nameSplit[nameSplit.length - 1].slice(0, 1)
      : name.slice(0, 2).toLocaleUpperCase();

  return (
    <Circle
      style={{ backgroundColor: stringToHslColor(name, 90, 80) }}
      alignItems="center"
      justifyContent="center"
      size={size}
      borderColor={"$pressablePrimaryBackground"}
      borderWidth={showBorder ? 3 : undefined}
    >
      <Label
        marginTop={3}
        fontSize={Math.min(maxSize ?? 40, Math.max(size - 24, 12))}
      >
        {initials.toUpperCase()}
      </Label>
    </Circle>
  );
};
